import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { ArticleGroup } from '../../model/article-group';
import { BrfTransferListItem } from '../../model/Transfer/brftransfer-list-item';
import { BrfTransferForm } from '../../model/Transfer/transfer-form';
import { ControlDataExportListItem } from '../../model/control-data/control-data-export-list-item';
import { ControlDataExportForm } from '../../model/control-data/control-data-export-form';

@Injectable()
export class ControlDataExportListService extends DataService<ControlDataExportListItem> {
  private readonly _defaultFilterFields: string[] = ['incomeYear', 'companyId', 'createdAt'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ControlDataExportListItem, progressBar, 'cd-export');
  }

  getFilterDefinition(): Observable<{
    incomeYear: number;
    companyId: string;
    rentalId: string;
    sellerContactName: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          incomeYear: res.incomeYear ? res.incomeYear : null,
          companyId: res.companyId ? res.companyId : null,
          createdAt: res.createdAt ? res.createdAt : null,
          selectedFields: Array.isArray(res.selectedFields) && res.selectedFields.length ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  CreateNewControlDataFile(id: string): Observable<any> {
    return this.client.post<boolean>(`${this.endpoint}/create-new-control-data-file/${id}`, {}).pipe(
      map((res: boolean) => {
        return res;
      }),
      catchError(error => {
        this.notification.showError(error);
        throw new Error();
      }),
      tap(() => this.notification.showSuccess('SUCCESS.HEADER'))
    );
  }
}
